<template>
  <el-container class="group-page">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="group-aside-width">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
        <el-button plain class="add-btn" icon="el-icon-plus" title="创建群聊" @click="onCreateGroup()"></el-button>
      </div>
      <el-scrollbar class="group-items">
        <div v-for="(groups, i) in groupValues" :key="i">
          <div class="letter">{{ groupKeys[i] }}</div>
          <div v-for="group in groups" :key="group.id">
            <group-item :id="group.id" :group="group" :active="group.id == activeGroup.id" @chat="onSendMessage(group)"
              @quit="onQuit(group)" @dissolve="onDissolve(group)" @card="onSendCard(group)"
              @click.native="onActiveItem(group)">
            </group-item>
          </div>
          <div v-if="i < groupValues.length - 1" class="divider"></div>
        </div>
      </el-scrollbar>
    </resizable-aside>
    <el-container class="container" v-show="activeGroup.id">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">{{ activeGroup.showGroupName }}
      </div>
      <div class="container-box">
        <div class="unified-card">
          <!-- 头部区域 -->
          <div class="card-header">
            <div class="avatar-section">
              <file-upload v-if="isOwner || isManager" class="avatar-uploader" :action="imageAction" :isPermanent="true"
				:custom-upload="true" :showLoading="true" :maxSize="maxSize" @upload="onUploadGroupAvatar"
                :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
                <head-image class="avatar" :size="80" :url="activeGroup.headImageThumb" radius="50%"
                  :name="activeGroup.showGroupName">
                </head-image>
                <div class="upload-overlay">
                  <i class="el-icon-camera"></i>
                  <span>更换头像</span>
                </div>
              </file-upload>
              <head-image v-else class="avatar" :size="80" :url="activeGroup.headImageThumb" radius="50%"
                :name="activeGroup.showGroupName">
              </head-image>
              <div class="group-info">
                <div class="group-header">
                  <div class="group-name"> {{ activeGroup.name }}
                    <el-tag v-if="activeGroup.isBanned" type="danger" size="small">已封禁</el-tag>
                  </div>
                  <div title="更多" class="more-btn el-icon-more" @click="onClickMore"></div>
                </div>
                <!-- 成员头像区域 -->
                <div class="members-preview">
                  <div class="members-avatars">
                    <div v-for="member in previewMembers" :key="member.id" class="member-avatar">
                      <head-image :size="36" :url="member.headImage" radius="50%" :name="member.showNickName"
                        :id="member.userId"></head-image>
                    </div>
                    <div v-if="showMembers.length > 6" class="more-members-btn" @click="openMemberDialog">
                      <span>+{{ showMembers.length - 6 }}</span>
                    </div>
                    <div class="view-all-btn" @click="openMemberDialog">
                      <span>查看全部成员</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 内容区域 -->
          <div class="card-content">
            <!-- 群信息 -->
            <div class="info-content">
              <el-form class="form" label-width="130px" :model="activeGroup" size="small" ref="groupForm">
                <el-form-item label="群主">
                  <div class="value">{{ ownerName }}</div>
                </el-form-item>
                <el-form-item label="群名">
                  <el-input v-model="activeGroup.name" :disabled="!isOwner && !isManager"
                    :placeholder="activeGroup.name" maxlength="32" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="备注名">
                  <el-input v-model="activeGroup.remarkGroupName" :placeholder="activeGroup.name" maxlength="32"
                    show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="我在本群的昵称">
                  <el-input v-model="activeGroup.remarkNickName" maxlength="20" :placeholder="mine.nickName"
                    show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="群公告">
                  <el-input v-model="activeGroup.notice" :disabled="!isOwner && !isManager" type="textarea"
                    :autosize="{ minRows: 3 }" maxlength="512" placeholder="群主未设置" show-word-limit></el-input>
                </el-form-item>
                <div class="btn-actions">
                  <el-button type="primary" icon="el-icon-position" @click="onSendMessage(activeGroup)">发消息</el-button>
                  <el-button type="success" @click="onSaveGroup()">保存</el-button>
                  <el-button type="danger" v-show="!isOwner" @click="onQuit(activeGroup)">退出</el-button>
                  <el-button type="danger" v-show="isOwner" @click="onDissolve(activeGroup)">解散</el-button>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </el-container>
    <right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
    <complaint ref="complaint"></complaint>
    <chat-selector ref="chatSel" title="分享名片"></chat-selector>
    <add-group-member ref="addGroupMember" :groupId="activeGroup.id" :teamType="activeGroup.teamType || 1" :members="groupMembers"
      @reload="reloadMembers()"></add-group-member>
    <group-member-selector ref="removeSelector" title="选择成员进行移除" :group="activeGroup" :groupMembers="groupMembers"
      @complete="onRemoveComplete"></group-member-selector>
    <group-member-selector ref="mutedSelector" title="选择成员进行禁言" :group="activeGroup" :groupMembers="groupMembers"
      @complete="onMutedComplete"></group-member-selector>
    <group-member-selector ref="unmutedSelector" title="选择成员进行解除禁言" :group="activeGroup" :groupMembers="groupMembers"
      @complete="onUnmutedComplete"></group-member-selector>

    <!-- 成员列表弹窗 -->
    <group-member-dialog ref="groupMemberDialog" :group="activeGroup" :groupMembers="groupMembers"
      @invite-member="onInviteMember" @remove-member="onRemoveMember" @muted="onMuted"
      @unmuted="onUnmuted"></group-member-dialog>

    <el-dialog title="创建群聊" :visible.sync="createGroupDialogVisible" width="560px" class="create-group-dialog"
      :close-on-click-modal="false" @open="onCreateGroupDialogOpen" @closed="onCreateGroupDialogClosed">
      <el-form ref="createGroupForm" :model="createGroupForm" :rules="createGroupRules" label-width="160px"
        size="small">
        <el-form-item label="群聊头像">
          <file-upload class="create-avatar-uploader" :action="imageAction" :isPermanent="true" :showLoading="true"
            :maxSize="maxSize" @success="onCreateAvatarUploadSuccess"
            :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
            <head-image class="create-avatar" :size="72" :url="createGroupForm.headImageThumb" radius="16px"
              :name="createGroupForm.name"></head-image>
            <div class="create-upload-overlay">
              <i class="el-icon-camera"></i>
              <span>上传头像</span>
            </div>
          </file-upload>
        </el-form-item>
        <el-form-item label="群聊名称" prop="name">
          <el-input v-model="createGroupForm.name" maxlength="32" show-word-limit placeholder="请输入群聊名称"></el-input>
        </el-form-item>
        <el-form-item label="群介绍">
          <el-input v-model="createGroupForm.intro" maxlength="100" show-word-limit placeholder="请输入群介绍"></el-input>
        </el-form-item>
        <el-form-item label="群公告">
          <el-input v-model="createGroupForm.notice" type="textarea" :autosize="{ minRows: 3 }" maxlength="512"
            show-word-limit placeholder="编辑群公告"></el-input>
        </el-form-item>
        <el-form-item label="允许群成员添加好友">
          <el-switch v-model="createGroupForm.groupConfig.allowAddFriend"></el-switch>
          <span class="switch-desc">关闭后，仅群主或管理员可在群内添加好友</span>
        </el-form-item>
        <el-form-item label="允许普通成员分享名片">
          <el-switch v-model="createGroupForm.groupConfig.isAllowShareCard"></el-switch>
          <span class="switch-desc">关闭后，仅群主或管理员可分享该群聊名片</span>
        </el-form-item>
        <el-form-item label="入群需验证">
          <el-switch v-model="createGroupForm.groupConfig.joinNeedVerify"></el-switch>
          <span class="switch-desc">开启后，主动申请入群需要审核</span>
        </el-form-item>
        <el-form-item label="邀请需对方同意">
          <el-switch v-model="createGroupForm.groupConfig.inviteeNeedAgree"></el-switch>
          <span class="switch-desc">关闭后，被邀请人将直接入群</span>
        </el-form-item>
        <el-form-item label="允许普通成员邀请">
          <el-switch v-model="createGroupForm.groupConfig.memberCanInvite"></el-switch>
          <span class="switch-desc">关闭后，仅群主或管理员可邀请</span>
        </el-form-item>
        <el-form-item label="允许普通成员改群资料">
          <el-switch v-model="createGroupForm.groupConfig.memberCanUpdateInfo"></el-switch>
          <span class="switch-desc">关闭后，仅群主或管理员可修改</span>
        </el-form-item>
        <el-form-item label="开启全员禁言">
          <el-switch v-model="createGroupForm.groupConfig.allMuted"></el-switch>
          <span class="switch-desc">创建后默认进入全员禁言状态</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createGroupDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="createGroupSubmitting" @click="submitCreateGroup">提交</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import GroupItem from '../components/group/GroupItem';
import FileUpload from '../components/common/FileUpload';
import GroupMemberItem from '../components/group/GroupMemberItem.vue';
import AddGroupMember from '../components/group/AddGroupMember.vue';
import GroupMemberSelector from '../components/group/GroupMemberSelector.vue';
import GroupMemberDialog from '../components/group/GroupMemberDialog.vue';
import HeadImage from '../components/common/HeadImage.vue';
import ChatSelector from '../components/chat/ChatSelector.vue';
import ResizableAside from '../components/common/ResizableAside.vue';
import { pinyin } from 'pinyin-pro';
import Complaint from '../components/common/Complaint.vue';
import RightMenu from "../components/common/RightMenu.vue";
import yunxinIM from '../api/yunxinIM.js';

export default {
  name: "group",
  components: {
    GroupItem,
    GroupMemberItem,
    FileUpload,
    AddGroupMember,
    GroupMemberSelector,
    GroupMemberDialog,
    HeadImage,
    ChatSelector,
    ResizableAside,
    Complaint,
    RightMenu
  },
  data() {
    return {
      searchText: "",
      maxSize: 5 * 1024 * 1024,
      activeGroup: {},
      groupMembers: [],
      bodyOverflowBeforeCreateDialog: '',
      createGroupDialogVisible: false,
      createGroupSubmitting: false,
      createGroupForm: {
        name: '',
        intro: '',
        notice: '',
        headImage: '',
        headImageThumb: '',
        groupConfig: {
          allowAddFriend: true,
          isAllowShareCard: true,
          joinNeedVerify: false,
          inviteeNeedAgree: true,
          memberCanInvite: false,
          memberCanUpdateInfo: false,
          allMuted: false
        }
      },
      createGroupRules: {
        name: [
          { required: true, message: '请输入群聊名称', trigger: 'blur' },
          { validator: this.validateCreateGroupName, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    onClickMore(e) {
      this.$refs.rightMenu.open(e, this.menuItems)
    },
    onSelectMenu(item) {
      switch (item.key) {
        case 'CHAT':
          this.onSendMessage(this.activeGroup);
          break;
        case 'CARD':
          this.onSendCard(this.activeGroup);
          break;
        case 'COMPLAINT':
          this.onComplaint(this.activeGroup);
          break;
        case 'DISSOLVE':
          this.onDissolve(this.activeGroup);
          break;
        case 'QUIT':
          this.onQuit(this.activeGroup);
          break;
      }
    },
    onCreateGroup() {
      this.createGroupForm = this.getInitialCreateGroupForm();
      this.createGroupDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.createGroupForm && this.$refs.createGroupForm.clearValidate();
      });
    },
    getInitialCreateGroupForm() {
      const userName = this.mine?.userName || this.mine?.nickName || '我';
      return {
        name: `${userName}创建的群聊`,
        intro: '',
        notice: '',
        headImage: '',
        headImageThumb: '',
        groupConfig: this.getDefaultGroupConfig()
      };
    },
    validateCreateGroupName(rule, value, callback) {
      const name = (value || '').trim();
      if (!name) {
        callback(new Error('请输入群聊名称'));
        return;
      }
      if (name.length > 32) {
        callback(new Error('群聊名称长度不能大于32'));
        return;
      }
      callback();
    },
    onCreateAvatarUploadSuccess(data) {
      this.createGroupForm.headImage = data.originUrl;
      this.createGroupForm.headImageThumb = data.thumbUrl || data.originUrl;
    },
    onCreateGroupDialogOpen() {
      this.bodyOverflowBeforeCreateDialog = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      window.addEventListener('wheel', this.preventCreateDialogBackgroundScroll, { passive: false, capture: true });
      window.addEventListener('touchmove', this.preventCreateDialogBackgroundScroll, { passive: false, capture: true });
    },
    onCreateGroupDialogClosed() {
      document.body.style.overflow = this.bodyOverflowBeforeCreateDialog;
      window.removeEventListener('wheel', this.preventCreateDialogBackgroundScroll, { capture: true });
      window.removeEventListener('touchmove', this.preventCreateDialogBackgroundScroll, { capture: true });
    },
    preventCreateDialogBackgroundScroll(event) {
      const dialog = event.target && event.target.closest && event.target.closest('.create-group-dialog .el-dialog');
      if (!dialog) {
        event.preventDefault();
      }
    },
    submitCreateGroup() {
      this.$refs.createGroupForm.validate(async valid => {
        if (!valid) {
          return;
        }
        this.createGroupSubmitting = true;
        try {
          const canCreate = await this.validateCreateGroupLimit();
          if (!canCreate) {
            return;
          }
          this.createGroupForm.name = this.createGroupForm.name.trim();
          const team = await yunxinIM.createTeam(this.buildCreateTeamParams(this.createGroupForm));
          const teamId = team.teamId || team.id;
          const serverGroup = await this.syncCreatedTeamToServer(teamId, this.createGroupForm);
          const group = this.normalizeSdkGroup(team, this.createGroupForm.name);
          group.serverGroupId = serverGroup?.id;
          this.groupStore.addGroup(group);
          this.chatStore.openChat({
            type: 'GROUP',
            targetId: group.id,
            showName: group.showGroupName,
            headImage: group.headImageThumb,
            isDnd: group.isDnd,
            isTop: group.isTop
          });
          this.onActiveItem(group);
          this.createGroupDialogVisible = false;
          this.$message.success('群聊创建成功，快邀请小伙伴进群吧');
        } catch (error) {
          console.error('[Group] 创建群聊失败:', error);
          this.$message.error(error?.message || '创建群聊失败');
        } finally {
          this.createGroupSubmitting = false;
        }
      });
    },
    getDefaultGroupConfig() {
      return {
        allowAddFriend: true,
        isAllowShareCard: true,
        joinNeedVerify: false,
        inviteeNeedAgree: true,
        memberCanInvite: false,
        memberCanUpdateInfo: false,
        allMuted: false
      };
    },
    buildGroupExtension(groupConfig = this.getDefaultGroupConfig()) {
      return JSON.stringify({
        allowAddFriend: groupConfig.allowAddFriend,
        isAllowShareCard: groupConfig.isAllowShareCard
      });
    },
    syncCreatedTeamToServer(teamId, groupForm) {
      if (!teamId) {
        throw new Error('云信群ID为空，无法同步保存群聊');
      }
      const groupConfig = groupForm.groupConfig || this.getDefaultGroupConfig();
      return this.$http({
        url: '/group/create',
        method: 'post',
        data: {
          name: groupForm.name,
          headImage: groupForm.headImageThumb || groupForm.headImage || '',
          headImageThumb: String(teamId),
          notice: groupForm.notice || '',
          isAllMuted: groupConfig.allMuted,
          isAllowInvite: groupConfig.memberCanInvite,
          isAllowShareCard: groupConfig.isAllowShareCard,
          allowAddFriend: groupConfig.allowAddFriend
        }
      });
    },
    buildCreateTeamParams(groupForm) {
      const form = typeof groupForm === 'string' ? { name: groupForm } : (groupForm || {});
      const groupConfig = form.groupConfig || this.getDefaultGroupConfig();
      const nim = yunxinIM.nim;
      const teamTypeEnum = nim.V2NIMTeamType || {};
      const joinModeEnum = nim.V2NIMTeamJoinMode || {};
      const agreeModeEnum = nim.V2NIMTeamAgreeMode || {};
      const inviteModeEnum = nim.V2NIMTeamInviteMode || {};
      const updateInfoModeEnum = nim.V2NIMTeamUpdateInfoMode || {};
      const updateExtensionModeEnum = nim.V2NIMTeamUpdateExtensionMode || {};
      const chatBannedModeEnum = nim.V2NIMTeamChatBannedMode || {};

      return {
        name: form.name,
        teamType: teamTypeEnum.V2NIM_TEAM_TYPE_ADVANCED ?? 1,
        memberLimit: 1000,
        intro: form.intro || '',
        announcement: form.notice || '',
        avatar: form.headImageThumb || form.headImage || '',
        joinMode: groupConfig.joinNeedVerify
          ? (joinModeEnum.V2NIM_TEAM_JOIN_MODE_APPLY ?? 1)
          : (joinModeEnum.V2NIM_TEAM_JOIN_MODE_FREE ?? 0),
        agreeMode: groupConfig.inviteeNeedAgree
          ? (agreeModeEnum.V2NIM_TEAM_AGREE_MODE_AUTH ?? 0)
          : (agreeModeEnum.V2NIM_TEAM_AGREE_MODE_NO_AUTH ?? 1),
        inviteMode: groupConfig.memberCanInvite
          ? (inviteModeEnum.V2NIM_TEAM_INVITE_MODE_ALL ?? 1)
          : (inviteModeEnum.V2NIM_TEAM_INVITE_MODE_MANAGER ?? 0),
        updateInfoMode: groupConfig.memberCanUpdateInfo
          ? (updateInfoModeEnum.V2NIM_TEAM_UPDATE_INFO_MODE_ALL ?? 1)
          : (updateInfoModeEnum.V2NIM_TEAM_UPDATE_INFO_MODE_MANAGER ?? 0),
        updateExtensionMode: updateExtensionModeEnum.V2NIM_TEAM_UPDATE_EXTENSION_MODE_MANAGER ?? 0,
        serverExtension: this.buildGroupExtension(groupConfig),
        chatBannedMode: groupConfig.allMuted
          ? (chatBannedModeEnum.V2NIM_TEAM_CHAT_BANNED_MODE_BANNED_NORMAL ?? 1)
          : (chatBannedModeEnum.V2NIM_TEAM_CHAT_BANNED_MODE_UNBAN ?? 0)
      };
    },
    getCurrentAccountId() {
      return this.mine.imAccid || this.mine.accountId || this.mine.id || yunxinIM.currentAccount;
    },
    buildCurrentMember() {
      return {
        userId: this.getCurrentAccountId(),
        nickName: this.mine.nickName,
        showNickName: this.mine.nickName,
        headImage: this.mine.headImageThumb || this.mine.headImage || '',
        online: true,
        isManager: false,
        isMuted: false,
        quit: false,
        version: 0
      };
    },
    parseGroupExtension(team = {}) {
      const rawExtension = team.serverExtension || team.ext || '';
      if (!rawExtension) {
        return {};
      }
      try {
        return typeof rawExtension === 'string' ? JSON.parse(rawExtension) : rawExtension;
      } catch (error) {
        console.warn('[Group] 解析群扩展字段失败:', error);
        return {};
      }
    },
    normalizeSdkGroup(team, fallbackName) {
      const groupExt = this.parseGroupExtension(team);
      const teamId = team.teamId || team.id;
		const avatar = team.avatar || '';
		const oldGroup = this.groupStore.findGroup(teamId) || this.activeGroup || {};
		const oldMemberCount = Number(oldGroup.memberCount || 0);
		const teamMemberCount = Number(team.memberCount);
		const memberCount = Number.isFinite(teamMemberCount) ? teamMemberCount : oldMemberCount;
		return {
        id: teamId,
        teamId,
        teamType: team.teamType || 1,
        name: team.name || fallbackName,
        showGroupName: oldGroup.remarkGroupName || team.name || fallbackName,
        headImage: avatar,
        headImageThumb: avatar,
        notice: team.announcement || '',
        intro: team.intro || '',
        serverExtension: team.serverExtension || team.ext || '',
			ownerId: team.ownerAccountId || team.ownerId || this.getCurrentAccountId(),
			members: oldGroup.members || [this.buildCurrentMember()],
			memberCount,
			quit: false,
        remarkGroupName: oldGroup.remarkGroupName || '',
        remarkNickName: oldGroup.remarkNickName || '',
        isDnd: oldGroup.isDnd || false,
        isTop: oldGroup.isTop || false,
        sdkCreated: true,
        allowAddFriend: groupExt.allowAddFriend !== false,
        isAllowInvite: Number(team.inviteMode) === 1,
        isAllowShareCard: groupExt.isAllowShareCard !== false
      };
    },
    async loadActiveSdkGroup(groupId, teamType = 1) {
      if (!groupId) {
        return;
      }
      let finalTeamType = teamType || 1;
      const team = await yunxinIM.getTeamInfo(groupId, finalTeamType).catch(async error => {
        if (finalTeamType !== 2) {
          finalTeamType = 2;
          return yunxinIM.getTeamInfo(groupId, finalTeamType);
        }
        throw error;
      });
      const members = await this.loadSdkMembers(groupId, team.teamType || finalTeamType);
		const finalMembers = members.length ? members : (this.activeGroup.members || []);
		const group = {
			...this.normalizeSdkGroup(team, this.activeGroup.name || this.activeGroup.showGroupName),
			members: finalMembers,
			memberCount: Number.isFinite(Number(team.memberCount)) ? Number(team.memberCount) : finalMembers.length
		};
		const myMember = finalMembers.find(member => String(member.userId || '') === String(this.getCurrentAccountId() || ''));
      if (myMember) {
        group.remarkNickName = myMember.showNickName || myMember.nickName || group.remarkNickName || '';
      }
		this.groupMembers = finalMembers;
      this.activeGroup = JSON.parse(JSON.stringify(group));
      if (this.groupStore.findGroup(group.id)) {
        this.groupStore.updateGroup(group);
      } else {
        this.groupStore.addGroup(group);
      }
      this.chatStore.updateChatFromGroup(group);
    },
    async loadSdkMembers(groupId, teamType = 1) {
      const sdkMembers = await yunxinIM.getTeamMemberList(groupId, teamType).catch(() => []);
      const accountIds = sdkMembers.map(member => String(member.accountId || member.teamMemberAccountId || member.memberAccountId || '')).filter(Boolean);
      const profiles = await yunxinIM.getUserProfiles(accountIds).catch(() => []);
      const profileMap = profiles.reduce((map, profile) => {
        map[String(profile.accountId || profile.id)] = profile;
        return map;
      }, {});
      return sdkMembers.map(member => {
        const accountId = String(member.accountId || member.teamMemberAccountId || member.memberAccountId || '');
        const profile = profileMap[accountId] || {};
        const nickName = profile.showNickName || profile.nickName || profile.name || accountId;
        const headImage = profile.headImageThumb || profile.headImage || profile.avatar || '';
        const role = Number(member.memberRole || member.teamMemberRole || member.role || 0);
				return {
					id: accountId,
					userId: accountId,
					role,
					nickName: member.teamNick || nickName,
					showNickName: member.teamNick || nickName,
          headImage,
          headImageThumb: headImage,
          online: false,
					isManager: role === 2 || String(member.memberRole ?? member.teamMemberRole ?? member.role ?? '').toLowerCase().includes('manager'),
          isMuted: !!(member.chatBanned || member.isMuted),
          quit: false,
          version: Number(member.updateTime || member.createTime || 0)
        };
      });
    },
    async validateCreateGroupLimit() {
      await this.userStore.loadUser();
      const rawLimit = this.userStore.userInfo.maxGroupLimit;
      if (rawLimit === '' || rawLimit === null || rawLimit === undefined) {
        return true;
      }
      const maxGroupLimit = Number(rawLimit);
      if (!Number.isFinite(maxGroupLimit) || maxGroupLimit < 0) {
        return true;
      }
      const joinedTeams = await yunxinIM.getJoinedTeamList([1, 2]);
      if ((joinedTeams || []).length >= maxGroupLimit) {
        this.$message.warning('已超出群限制，无法继续创建');
        return false;
      }
      return true;
    },
    async onActiveItem(group) {
      this.showMaxIdx = 50;
      // store数据不能直接修改，所以深拷贝一份内存
      this.activeGroup = JSON.parse(JSON.stringify(group));
      await this.loadActiveSdkGroup(group.id || group.teamId, group.teamType || 1).catch(error => {
        console.error('[Group] 加载群资料失败:', error);
        this.$message.error(error?.message || '加载群资料失败');
      });
    },
    onSendCard(group) {
      this.$refs.chatSel.open(async chats => {
        if (!chats || !chats.length) return;
        const cardData = {
          groupId: group.id || group.teamId,
          groupName: group.showGroupName || group.name,
          headImage: group.headImageThumb || group.headImage
        };
        let successCount = 0;
        for (const chat of chats) {
          try {
            const message = await yunxinIM.sendLegacyCardMessage(chat, this.$enums.MESSAGE_TYPE.GROUP_CARD, cardData);
            this.chatStore.openChat(chat);
            this.chatStore.insertMessage(message, chat);
            successCount++;
          } catch (error) {
            console.error('[Group] 分享群名片失败:', error);
          }
        }
        if (successCount > 0) {
          this.$message.success(`成功发送名片到${successCount}个联系人`);
        }
        if (successCount < chats.length) {
          this.$message.warning(`${chats.length - successCount}个联系人发送失败`);
        }
      })
    },
    onComplaint(group) {
      this.$refs.complaint.open(2, group.id, group.name)
    },
    onInviteMember() {
      this.$refs.addGroupMember.open();
    },
    onRemoveMember() {
      // 群主和自己不显示
      let hideIds = [this.activeGroup.ownerId, this.getCurrentAccountId()];
      // 只有群主可以移除管理员
      if (!this.isOwner) {
        hideIds = hideIds.concat(this.managerIds);
      }
      this.$refs.removeSelector.open(50, [], [], hideIds);
    },
    async onRemoveComplete(members) {
      let userIds = members.map(m => m.userId);
      if (!userIds.length) {
        return;
      }
      try {
        await yunxinIM.kickTeamMembers(this.activeGroup.id, this.activeGroup.teamType || 1, userIds);
        this.markMembersQuit(userIds);
        this.reloadMembers();
        this.$message.success(`您移除了${userIds.length}位成员`);
      } catch (error) {
        console.error('[Group] 移除群成员失败:', error);
        this.$message.error(error?.message || '移除成员失败');
      }
    },
    onMuted() {
      // 群主和自己不显示
      let hideIds = [this.activeGroup.ownerId, this.getCurrentAccountId()];
      // 只有群主可以禁言管理员
      if (!this.isOwner) {
        hideIds = hideIds.concat(this.managerIds);
      }
      // 已禁言的用户不可选中
      let lockedIds = this.groupMembers.filter(m => m.isMuted).map(m => m.userId);
      this.$refs.mutedSelector.open(50, [], lockedIds, hideIds);

    },
    onMutedComplete(members) {
      let userIds = members.map(m => m.userId);
      let tip = `您对${userIds.length}位成员进行了禁言`;
      this.sendMemberMuted(userIds, true, tip);
    },
    onUnmuted() {
      // 过滤掉未禁言的用户
      let hideIds = this.groupMembers.filter(m => !m.isMuted).map(m => m.userId)
      // 只有群主可以解除管理员的禁言
      if (!this.isOwner) {
        hideIds = hideIds.concat(this.managerIds);
      }
      this.$refs.unmutedSelector.open(50, [], [], hideIds);
    },
    onUnmutedComplete(members) {
      let userIds = members.map(m => m.userId);
      let tip = `您解除了${userIds.length}位成员的禁言`;
      this.sendMemberMuted(userIds, false, tip);
    },
    getSdkUploadUrl(result = {}) {
      if (typeof result === 'string') {
        return result;
      }
      return result.url || result.downloadUrl || result.fileUrl || result.path || result.uri || '';
    },
    async onUploadGroupAvatar(file) {
      if (!this.isOwner && !this.isManager) {
        this.$message.warning('只有群主或管理员可以修改群头像');
        return;
      }
      const oldHeadImage = this.activeGroup.headImage;
      const oldHeadImageThumb = this.activeGroup.headImageThumb;
      const loading = this.$loading({
        lock: true,
        text: '正在上传群头像...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        const uploadResult = await yunxinIM.uploadFile(file, 'nim_default_profile');
        const avatar = this.getSdkUploadUrl(uploadResult);
        if (!avatar) {
          throw new Error('云信头像上传结果缺少 URL');
        }
        await yunxinIM.updateTeamInfo(this.activeGroup.id, this.activeGroup.teamType || 1, { avatar });
        this.activeGroup.headImage = avatar;
        this.activeGroup.headImageThumb = avatar;
        this.groupStore.updateGroup({ ...this.activeGroup, members: this.groupMembers });
        this.chatStore.updateChatFromGroup(this.activeGroup);
        this.$message.success('群头像修改成功');
      } catch (error) {
        console.error('[Group] 修改群头像失败:', error);
        this.activeGroup.headImage = oldHeadImage;
        this.activeGroup.headImageThumb = oldHeadImageThumb;
        this.$message.error(error?.message || '修改失败');
      } finally {
        loading.close();
      }
    },
    onSaveGroup() {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.saveSdkGroupInfo();
        }
      });
    },
    async saveSdkGroupInfo() {
      const group = this.activeGroup;
      const teamType = group.teamType || 1;
      try {
        if (this.isOwner || this.isManager) {
          await yunxinIM.updateTeamInfo(group.id, teamType, {
            name: group.name || '',
            announcement: group.notice || ''
          });
        }
        if (group.remarkNickName) {
          await yunxinIM.updateSelfTeamMemberInfo(group.id, teamType, {
            teamNick: group.remarkNickName
          }).catch(error => {
            console.warn('[Group] 修改群昵称失败:', error);
          });
        }
        const nextGroup = {
          ...group,
          showGroupName: group.remarkGroupName || group.name,
          members: this.groupMembers
        };
        this.activeGroup = JSON.parse(JSON.stringify(nextGroup));
        this.groupStore.updateGroup(nextGroup);
        this.chatStore.updateChatFromGroup(nextGroup);
        this.$message.success('修改成功');
      } catch (error) {
        console.error('[Group] 修改群资料失败:', error);
        this.$message.error(error?.message || '修改失败');
      }
    },
    onDissolve(group) {
      this.$confirm(`确认要解散'${group.name}'吗?`, '确认解散?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await yunxinIM.dismissTeam(group.id, group.teamType || 1);
          this.$message.success(`群聊'${group.name}'已解散`);
          this.groupStore.removeGroup(group.id);
          this.chatStore.removeGroupChat(group.id);
          this.reset();
        } catch (error) {
          console.error('[Group] 解散群聊失败:', error);
          this.$message.error(error?.message || '解散群聊失败');
        }
      })
    },
    onQuit(group) {
      this.$confirm(`确认退出'${group.showGroupName}',并清空聊天记录吗？`, '确认退出?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await yunxinIM.leaveTeam(group.id, group.teamType || 1);
          this.$message.success(`您已退出'${group.name}'`);
          this.groupStore.removeGroup(group.id);
          this.chatStore.removeGroupChat(group.id);
          this.reset();
        } catch (error) {
          console.error('[Group] 退出群聊失败:', error);
          this.$message.error(error?.message || '退出群聊失败');
        }
      })
    },
    onSendMessage(group) {
      let chat = {
        type: 'GROUP',
        targetId: group.id,
        showName: group.showGroupName,
        headImage: group.headImageThumb,
        isDnd: group.isDnd,
        isTop: group.isTop
      };
      this.chatStore.openChat(chat);
      this.chatStore.setActiveChat(chat);
      this.$router.push("/home/chat");
    },

    locateItem(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    },
    async sendMemberMuted(userIds, isMuted, tip) {
      if (!userIds.length) {
        return;
      }
      try {
        await yunxinIM.setTeamMembersMute(this.activeGroup.id, this.activeGroup.teamType || 1, userIds, isMuted);
        this.markMembersMuted(userIds, isMuted);
        this.reloadMembers();
        this.$message.success(tip);
      } catch (error) {
        console.error('[Group] 设置群成员禁言失败:', error);
        this.$message.error(error?.message || '操作失败');
      }
    },
    markMembersQuit(userIds) {
      this.groupMembers.forEach(member => {
        if (userIds.some(userId => String(userId) === String(member.userId))) {
          member.quit = true;
        }
      });
    },
    markMembersMuted(userIds, isMuted) {
      this.groupMembers.forEach(member => {
        if (userIds.some(userId => String(userId) === String(member.userId))) {
          member.isMuted = isMuted;
        }
      });
    },
    async reloadMembers() {
      if (!this.activeGroup.id) {
        return;
      }
      const members = await this.loadSdkMembers(this.activeGroup.id, this.activeGroup.teamType || 1);
      this.groupMembers = members;
      const group = {
        ...this.activeGroup,
        members
      };
      this.activeGroup = JSON.parse(JSON.stringify(group));
      this.groupStore.updateGroup(group);
    },
    reset() {
      this.activeGroup = {};
      this.groupMembers = [];
    },
    firstLetter(strText) {
      // 使用pinyin-pro库将中文转换为拼音
      let pinyinOptions = {
        toneType: 'none', // 无声调
        type: 'normal' // 普通拼音
      };
      let pyText = pinyin(strText, pinyinOptions);
      return pyText[0];
    },
    isEnglish(character) {
      return /^[A-Za-z]+$/.test(character);
    },
    openMemberDialog() {
      this.$refs.groupMemberDialog.open();
    }
  },
  computed: {
    mine() {
      return this.userStore.userInfo;
    },
    ownerName() {
      let member = this.groupMembers.find((m) => String(m.userId || '') === String(this.activeGroup.ownerId || ''));
      return member && member.showNickName;
    },
    isOwner() {
      return String(this.activeGroup.ownerId || '') === String(this.getCurrentAccountId() || '');
    },
    isManager() {
      let userId = this.getCurrentAccountId();
      let m = this.groupMembers.find((m) => String(m.userId || '') === String(userId || ''));
      return m && m.isManager;
    },
    isAllowShareCard() {
      return this.isOwner || this.isManager || this.activeGroup.isAllowShareCard;
    },
    managerIds() {
      return this.groupMembers.filter(m => m.isManager).map(m => m.userId)
    },
    imageAction() {
      return `/image/upload?thumbSize=20`;
    },
    groupMap() {
      // 按首字母分组
      let map = new Map();
      this.groupStore.groups.forEach((g) => {
        if (g.quit || (this.searchText && !g.showGroupName.includes(this.searchText))) {
          return;
        }
        let letter = this.firstLetter(g.showGroupName).toUpperCase();
        // 非英文一律为#组
        if (!this.isEnglish(letter)) {
          letter = "#"
        }
        if (map.has(letter)) {
          map.get(letter).push(g);
        } else {
          map.set(letter, [g]);
        }
      })
      // 排序
      let arrayObj = Array.from(map);
      arrayObj.sort((a, b) => {
        // #组在最后面
        if (a[0] == '#' || b[0] == '#') {
          return b[0].localeCompare(a[0])
        }
        return a[0].localeCompare(b[0])
      })
      map = new Map(arrayObj.map(i => [i[0], i[1]]));
      return map;
    },
    groupKeys() {
      return Array.from(this.groupMap.keys());
    },
    groupValues() {
      return Array.from(this.groupMap.values());
    },
    showMembers() {
      return this.groupMembers.filter((m) => !m.quit)
    },
    previewMembers() {
      return this.showMembers.slice(0, 6);
    },
    menuItems() {
      let items = [];
      items.push({
        key: 'CHAT',
        name: '发送消息',
      });
      if (this.isAllowShareCard) {
        items.push({
          key: 'CARD',
          name: '分享名片',
        });
      }
      items.push({
        key: 'COMPLAINT',
        name: '投诉',
      });
      if (this.isOwner) {
        items.push({
          key: 'DISSOLVE',
          name: '解散群聊',
          danger: true
        });
      } else {
        items.push({
          key: 'QUIT',
          name: '退出群聊',
          danger: true
        });
      }
      return items;
    }
  },
  mounted() {
    // 选中群聊
    let groupId = this.$route.query.id;
    if (groupId) {
      let group = this.groupStore.findGroup(groupId);
      if (group) {
        this.onActiveItem(group);
        this.locateItem(group.id);
      }
    }
  },
  beforeDestroy() {
    this.onCreateGroupDialogClosed();
  }
}
</script>

<style lang="scss" scoped>
.group-page {

  .divider {
    border-bottom: 1px #ddd solid;
    margin: 10px;
  }

  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;

    .add-btn {
      padding: 8px;
      margin: 5px;
      font-size: 16px;
      border-radius: 50%;
      background: var(--im-background-active);
      color: var(--im-color-primary);
      transition: all 0.3s ease;
      font-weight: 600;
      border: var(--im-border);

      &:hover {
        background: var(--im-background-active-dark);
        transform: scale(1.1);
      }
    }
  }

  .group-items {
    flex: 1;

    .letter {
      text-align: left;
      font-size: var(--im-larger-size-larger);
      margin: 5px 15px;
      color: var(--im-text-color-light);
    }
  }

  .container {
    display: flex;
    flex-direction: column;
    background: #fcfdff;

    .header {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;
      line-height: 60px;
      font-size: var(--im-font-size-larger);
      border-bottom: var(--im-border);
    }

    .el-divider--horizontal {
      margin: 16px 0;
    }

    .container-box {
      overflow: auto;
      padding: 20px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;


      .unified-card {
        display: flex;
        flex-direction: column;
        width: 100%;
        border-radius: 20px;
        overflow: hidden;

        .card-header {
          padding: 20px 30px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.06);

          .avatar-section {
            display: flex;
            align-items: center;
            padding: 0 20px;

            .avatar {
              position: relative;
            }

            .avatar-uploader {
              position: relative;
              display: inline-block;

              .el-upload {
                border: none !important;
                border-radius: 50%;
                cursor: pointer;
                position: relative;
                overflow: hidden;
              }

              .upload-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.6);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: white;
                font-size: 12px;
                border-radius: 50%;
                opacity: 0;
                transition: all 0.3s ease;

                i {
                  font-size: 18px;
                  margin-bottom: 4px;
                }

                span {
                  font-size: 10px;
                  font-weight: 500;
                }
              }

              &:hover .upload-overlay {
                opacity: 1;
              }
            }

            .group-info {
              flex: 1;
              display: flex;
              flex-direction: column;
              margin: 0 20px;

              .group-header {
                padding: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;


                .group-name {
                  font-size: 24px;
                  font-weight: 700;
                  color: var(--im-text-color-primary);
                  letter-spacing: -0.5px;
                  display: flex;
                  align-items: center;
                  gap: 12px;
                  margin: 0;
                }

                .more-btn {
                  font-size: 20px;
                  cursor: pointer;
                  padding: 8px;
                  border-radius: 50%;
                  transition: all 0.3s ease;
                  background: var(--im-background-active);
                  color: var(--im-color-primary);
                  margin: 0;

                  &:hover {
                    background: var(--im-background-active-dark);
                    transform: scale(1.1);
                  }
                }
              }

              .members-preview {
                background: rgba(255, 255, 255, 0.6);
                border-radius: 12px;
                padding: 12px 16px;
                border: 1px solid rgba(0, 0, 0, 0.06);
                box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

                .members-avatars {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  flex-wrap: wrap;

                  .member-avatar {
                    position: relative;
                    transition: all 0.3s ease;

                    &:hover {
                      transform: scale(1.1);
                    }
                  }

                  .more-members-btn {
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    background: var(--im-color-primary-light-2);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);

                    &:hover {
                      transform: scale(1.1);
                      box-shadow: 0 4px 16px rgba(64, 158, 255, 0.4);
                    }
                  }

                  .view-all-btn {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    padding: 6px 12px;
                    background: var(--im-color-primary-light-2);
                    color: white;
                    border-radius: 16px;
                    font-size: var(--im-font-size-smaller);
                    font-weight: 500;
                    cursor: pointer;
                    margin-left: 8px;

                    i {
                      font-size: 10px;
                    }
                  }
                }
              }
            }

          }
        }

        .card-content {
          padding: 12px;
          border-radius: 12px;

          .info-content {
            .form {
              padding: 10px;

              .el-form-item {
                text-align: left;

                .value {
                  color: var(--im-text-color-light);
                }
              }

              .btn-actions {
                margin-top: 40px;
                text-align: center;

                .el-button {
                  margin: 0 8px;
                }
              }
            }
          }
        }
      }
    }
  }

  .create-group-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;

    ::v-deep .el-dialog {
      margin: 0 !important;
      max-height: calc(100vh - 48px);
      display: flex;
      flex-direction: column;
    }

    ::v-deep .el-dialog__body {
      padding: 18px 28px 6px;
      flex: 1;
      max-height: none;
      overflow: auto;
    }

    .create-avatar-uploader {
      position: relative;
      display: inline-block;

      ::v-deep .el-upload {
        position: relative;
        overflow: hidden;
        border-radius: 16px;
        cursor: pointer;
      }

      .create-upload-overlay {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        background: rgba(0, 0, 0, 0.52);
        border-radius: 16px;
        font-size: 12px;
        opacity: 0;
        transition: opacity 0.2s ease;

        i {
          margin-bottom: 4px;
          font-size: 18px;
        }
      }

      &:hover .create-upload-overlay {
        opacity: 1;
      }
    }

    .switch-desc {
      margin-left: 12px;
      color: var(--im-text-color-light);
      font-size: var(--im-font-size-smaller);
    }
  }

}
</style>
